import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarMoveToTrashIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-move-to-trash"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                fill="#48505E"
                d="M17.786 7.25c.75 0 1.385.551 1.457 1.278l.007.139V9.75h4.495a.75.75 0 0 1 .102 1.493l-.102.007h-.76l.001 10.966a2.75 2.75 0 0 1-2.582 2.745l-.168.005h-8.435a2.75 2.75 0 0 1-2.75-2.75V11.25h-.79a.75.75 0 0 1-.102-1.493l.102-.007h4.489V8.667c0-.748.59-1.343 1.325-1.41l.14-.007h3.57zm3.7 4H10.551v10.966c0 .647.492 1.18 1.122 1.243l.128.007h8.435c.69 0 1.25-.56 1.25-1.25V11.25zm-3.736-2.5h-3.5v1h3.5v-1z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarMoveToTrashIcon);
export default Memo;
